import Form from "../modules/form/form";

export default function () {
	let forms_timeout;
	// Some crazy hacks to beat FA Boss Glich with errors in fields parsing.
	function loadForm() {
		forms_timeout = setTimeout(function () {
			new Form();
		}, 500);
	}

	loadForm();
	document.addEventListener('FA__DOMContentLoaded', function () {
		if (forms_timeout) {
			clearTimeout(forms_timeout);
		}
		loadForm();
	})
}

